import { render, staticRenderFns } from "./admin-controller.vue?vue&type=template&id=47882d93"
import script from "./admin-controller.vue?vue&type=script&lang=js"
export * from "./admin-controller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports